import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, Injectable, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthComponent } from "./layout/auth/auth.component";
import { AuthHeaderComponent } from "./common/auth-header/auth-header.component";
import { AuthSidebarComponent } from "./common/auth-sidebar/auth-sidebar.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AfterAuthComponent } from "./layout/after-auth/after-auth.component";
import { LoggedComponent } from "./layout/logged/logged.component";
import { SidebarComponent } from "./common/sidebar/sidebar.component";
import { HeaderComponent } from "./common/header/header.component";
import { MessagingService } from "./Services/messaging.service";
import { AngularFireDatabaseModule } from "@angular/fire/database";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFireMessagingModule } from "@angular/fire/messaging";
import { AngularFireModule } from "@angular/fire";
import { environment } from "src/environments/environment";
import { AsyncPipe, DecimalPipe } from "@angular/common";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ExchangeComponent } from "./layout/exchange/exchange.component";
import { ToastrModule } from "ngx-toastr";
import { LandingComponent } from "./layout/landing/landing.component";
import { HomeHeaderComponent } from "./common/home-header/home-header.component";
import { HomeFooterComponent } from "./common/home-footer/home-footer.component";
import { TourNgxBootstrapModule } from "ngx-tour-ngx-bootstrap";
import { TourModule } from "./pages/tour/tour.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SharedModule } from "./shared/shared.module";
import { InterceptorService } from "./Services/interceptor.service";
import { CalculatorWidgetComponent } from "./layout/calculator-widget/calculator-widget.component";
import { ModalComponent } from "./common/calculator-modal/modal/modal.component";
import { DraggableModule } from "./common/calculator-modal/draggable/draggable-module";
import { ResizableModule } from "./common/calculator-modal/resizable/resizable.module";
import { CalculatorComponent } from "./pages/calculator/calculator.component";
import { QuickExchangePopupModule } from "./pages/quick-exchange-popup/quick-exchange-popup.module";
import { QuickTransferModalModule } from "./pages/quick-tranfer-modal/quick-transfer-modal.module";
import { LoggerHelper } from "./shared/helper/loggerHelper";
import { ConsumerService } from "./shared/services/consumer.service";
import * as Sentry from "@sentry/browser";
import { ObsicashStoreService } from "./Services/obsicash/obsicash-store.service";
import { UrlSerializer } from "@angular/router";
import { CustomUrlSerializer } from "./shared/models/UrlSerializer/custom-url-serializer";
import { BnNgIdleService } from "bn-ng-idle";
import {
  ObsidiamJweComponent,
  ObsidiamJweModule,
} from "projects/obsidiam-jwe/src/public-api";
import { FirebaseService } from "./shared/services/firebase.service";

const rxjsservices = [InterceptorService];

/*Sentry.init({
  dsn: 'https://e87a4c78a17c4884b67af8e70cfe0d43@o351233.ingest.sentry.io/2503613',
  environment: environment.env
});*/
@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(error) {
    const exception = error.error || error.message || error.originalError || error;
    Sentry.captureException(exception);
  }
}
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: any): void {
   const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }
    console.error(error);
  }
}
@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    AuthHeaderComponent,
    AuthSidebarComponent,
    AfterAuthComponent,
    LoggedComponent,
    SidebarComponent,
    HeaderComponent,
    ExchangeComponent,
    LandingComponent,
    HomeHeaderComponent,
    HomeFooterComponent,
    CalculatorWidgetComponent,
    ModalComponent,
    CalculatorComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    NgbModule,
    SharedModule,
    DraggableModule,
    ResizableModule,
    QuickExchangePopupModule,
    QuickTransferModalModule,
    ObsidiamJweModule,
    AngularFireModule.initializeApp(environment.firebase),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ToastrModule.forRoot({
      preventDuplicates: false,
    }),
    TourNgxBootstrapModule.forRoot(),
    TourModule,
  ],
  providers: [
    FirebaseService,
    CookieService,
    MessagingService,
    AsyncPipe,
    DecimalPipe,
    LoggerHelper,
    ConsumerService,
    ObsicashStoreService,
    BnNgIdleService,
    ObsidiamJweComponent,
    rxjsservices,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    { provide: UrlSerializer, useClass: CustomUrlSerializer },

  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  // return new TranslateHttpLoader(http);
  return new TranslateHttpLoader(
    http,
    "./assets/i18n/",
    ".json?v=" + environment.version
  );
}
